<template>
  <div>
    <v-row justify="center">
      <v-dialog
          v-model="dialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
          @keydown.esc="avisoCerrar"
          persistent
        >
          <v-card tile>
            <v-toolbar
              flat
              dark
              color="primary"
            >
              <v-btn
                icon
                dark
                @click="avisoCerrar"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>
                <span v-if="!editandoUsuario && !usuario.name && !usuario.apellidos">
                  Nuevo Usuario
                </span>
                <span>
                  {{ usuario.name }} {{ usuario.apellidos }}
                </span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  dark
                  text
                  @click="guardar"
                  :disabled="$v.passconfirm.$invalid || $v.usuario.$invalid"
                >
                  Guardar
                </v-btn>
              </v-toolbar-items>
              <v-menu
                bottom
                right
                offset-y
              >
              </v-menu>
            </v-toolbar>
            <v-card-text>
              <v-expansion-panels
                v-model="panel"
                multiple
              >
                <v-expansion-panel class="mt-4">
                  <v-expansion-panel-header class="text-h6">Información Básica</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row no-gutters>
                      <v-col cols="12" sm="2" md="2" class="align-self-center d-flex justify-center">
                        <v-avatar
                          :color="usuario.color"
                          size="56"
                        >
                          <span class="white--text headline">
                            {{ usuario.avatar }}
                          </span>
                        </v-avatar>
                      </v-col>
                      <v-col cols="12" sm="10" md="10">
                        <v-row>
                          <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field
                              v-model="usuario.name"
                              v-on:input="setAvatar()"
                              label="Nombre"
                              prepend-icon="mdi-account-outline"
                              :error-messages="errorNombre"
                              @input="$v.usuario.name.$touch()"
                              @blur="$v.usuario.name.$touch()"
                              required
                              class="anadirAsterisco"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="8" md="8" class="pt-0 pb-0">
                            <v-text-field
                              v-model="usuario.apellidos"
                              v-on:input="setAvatar()"
                              label="Apellidos"
                              :error-messages="errorApellido"
                              @input="$v.usuario.apellidos.$touch()"
                              @blur="$v.usuario.apellidos.$touch()"
                              required
                              class="anadirAsterisco"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="pt-0 pb-0">
                              <v-text-field
                                v-model="usuario.email"
                                label="Email"
                                prepend-icon="mdi-email-outline"
                                :error-messages="errorEmail"
                                @input="$v.usuario.email.$touch()"
                                @blur="$v.usuario.email.$touch()"
                                :disabled="editandoUsuario"
                                class="anadirAsterisco"
                              ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-if="editandoUsuario">
                          <v-btn
                            color="warning"
                            class="ma-2"
                            outlined
                            v-if="!resetPassword"
                            @click="resetPassword = !resetPassword"
                          >
                          <v-icon
                              left
                              dark
                            >
                              mdi-key-outline
                            </v-icon>
                            Restablecer contraseña
                          </v-btn>
                        </v-row>
                        <v-row v-if="!editandoUsuario || resetPassword">
                          <v-col cols="12" sm="6" md="6" class="pt-0 pb-0">
                            <v-text-field
                              v-model="usuario.password"
                              prepend-icon="mdi-key-outline"
                              :error-messages="errorPassword"
                              @input="$v.usuario.password.$touch()"
                              @blur="$v.usuario.password.$touch()"
                              :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                              :type="showPass ? 'text' : 'password'"
                              name="password"
                              label="Contraseña"
                              hint="Letras, números y mayúsculas"
                              counter
                              @click:append="showPass = !showPass"
                              class="anadirAsterisco"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6" class="pt-0 pb-0">
                            <v-text-field
                              v-model="passconfirm"
                              :append-icon="showPassConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                              :error-messages="errorPassconfirm"
                              @input="$v.passconfirm.$touch()"
                              @blur="$v.passconfirm.$touch()"
                              :type="showPassConfirm ? 'text' : 'password'"
                              name="passconfirm"
                              label="Confirmar contraseña"
                              counter
                              @click:append="showPassConfirm = !showPassConfirm"
                              class="anadirAsterisco"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="text-h6">Información Adicional</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" class="pt-0 pb-0">
                        <v-text-field
                          v-model="usuario.extension"
                          label="Extension"
                          prepend-icon="mdi-phone-outline"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="pt-0 pb-0">
                        <v-text-field
                          v-model="usuario.telefono"
                          :error-messages="errorTelefono"
                          @input="$v.usuario.telefono.$touch()"
                          @blur="$v.usuario.telefono.$touch()"
                          label="Teléfono"
                          prepend-icon="mdi-phone-outline"
                          required
                          maxlength="9"
                          class="anadirAsterisco"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="pt-0 pb-0">
                        <v-textarea
                          prepend-icon="mdi-note-text-outline"
                          label="Observaciones"
                          v-model="usuario.observaciones"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-select
                          v-model="usuario.equipos"
                          :items="equipos"
                          item-text="nombre"
                          item-value="id"
                          :menu-props="{ top: true }"
                          attach
                          chips
                          label="Equipos"
                          multiple
                          prepend-icon="mdi-account-group-outline"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="text-h6">Horario</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row justify="center">
                      <v-col cols="12" sm="6" md="4">
                        <h3 class="ml-4 mr-1">Lunes <v-icon @click="inicializarDatosEdicion(0)" color="primary">mdi-calendar-edit</v-icon></h3>
                        <v-row>
                          <v-col class="ml-5 mt-2" style="max-width: 80px;">Mañana</v-col>
                          <v-col class="pt-2"><v-text-field v-model="horario[0].entradaManana" label="Inicio" disabled dense></v-text-field></v-col>
                          <v-col class="pt-2"><v-text-field v-model="horario[0].salidaManana" label="Fin" disabled dense></v-text-field></v-col>
                        </v-row>
                        <v-row>
                          <v-col class="ml-5 mt-0" style="max-width: 80px;">Tarde</v-col>
                          <v-col class="pt-0"><v-text-field v-model="horario[0].entradaTarde" label="Inicio" disabled dense></v-text-field></v-col>
                          <v-col class="pt-0"><v-text-field v-model="horario[0].salidaTarde" label="Fin" disabled dense></v-text-field></v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <h3 class="ml-4 mr-1">Martes <v-icon @click="inicializarDatosEdicion(1)" color="primary">mdi-calendar-edit</v-icon></h3>
                        <v-row>
                          <v-col class="ml-5 mt-2" style="max-width: 80px;">Mañana</v-col>
                          <v-col class="pt-2"><v-text-field v-model="horario[1].entradaManana" label="Inicio" disabled dense></v-text-field></v-col>
                          <v-col class="pt-2"><v-text-field v-model="horario[1].salidaManana" label="Fin" disabled dense></v-text-field></v-col>
                        </v-row>
                        <v-row>
                          <v-col class="ml-5 mt-0" style="max-width: 80px;">Tarde</v-col>
                          <v-col class="pt-0"><v-text-field v-model="horario[1].entradaTarde" label="Inicio" disabled dense></v-text-field></v-col>
                          <v-col class="pt-0"><v-text-field v-model="horario[1].salidaTarde" label="Fin" disabled dense></v-text-field></v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <h3 class="ml-4 mr-1">Miercoles <v-icon @click="inicializarDatosEdicion(2)" color="primary">mdi-calendar-edit</v-icon></h3>
                        <v-row>
                          <v-col class="ml-5 mt-2" style="max-width: 80px;">Mañana</v-col>
                          <v-col class="pt-2"><v-text-field v-model="horario[2].entradaManana" label="Inicio" disabled dense></v-text-field></v-col>
                          <v-col class="pt-2"><v-text-field v-model="horario[2].salidaManana" label="Fin" disabled dense></v-text-field></v-col>
                        </v-row>
                        <v-row>
                          <v-col class="ml-5" style="max-width: 80px;">Tarde</v-col>
                          <v-col class="pt-0"><v-text-field v-model="horario[2].entradaTarde" label="Inicio" disabled dense></v-text-field></v-col>
                          <v-col class="pt-0"><v-text-field v-model="horario[2].salidaTarde" label="Fin" disabled dense></v-text-field></v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <h3 class="mt-2 ml-4 mr-1">Jueves <v-icon @click="inicializarDatosEdicion(3)" color="primary">mdi-calendar-edit</v-icon></h3>
                        <v-row>
                          <v-col class="ml-5 mt-2" style="max-width: 100px;">Mañana</v-col>
                          <v-col class="pt-2"><v-text-field v-model="horario[3].entradaManana" label="Inicio" disabled dense></v-text-field></v-col>
                          <v-col class="pt-2"><v-text-field v-model="horario[3].salidaManana" label="Fin" disabled dense></v-text-field></v-col>
                        </v-row>
                        <v-row>
                          <v-col class="ml-5" style="max-width: 100px;">Tarde</v-col>
                          <v-col class="pt-0"><v-text-field v-model="horario[3].entradaTarde" label="Inicio" disabled dense></v-text-field></v-col>
                          <v-col class="pt-0"><v-text-field v-model="horario[3].salidaTarde" label="Fin" disabled dense></v-text-field></v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <h3 class="mt-2 ml-4 mr-1">Viernes <v-icon @click="inicializarDatosEdicion(4)" color="primary">mdi-calendar-edit</v-icon></h3>
                        <v-row>
                          <v-col class="ml-5 mt-2" style="max-width: 100px;">Mañana</v-col>
                          <v-col class="pt-2"><v-text-field v-model="horario[4].entradaManana" label="Inicio" disabled dense></v-text-field></v-col>
                          <v-col class="pt-2"><v-text-field v-model="horario[4].salidaManana" label="Fin" disabled dense></v-text-field></v-col>
                        </v-row>
                        <v-row>
                          <v-col class="ml-5" style="max-width: 100px;">Tarde</v-col>
                          <v-col class="pt-0"><v-text-field v-model="horario[4].entradaTarde" label="Inicio" disabled dense></v-text-field></v-col>
                          <v-col class="pt-0"><v-text-field v-model="horario[4].salidaTarde" label="Fin" disabled dense></v-text-field></v-col>
                        </v-row>
                      </v-col>
                    </v-row>                    
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="text-h6">Configuración</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12">
                        <p class="font-weight-medium">
                          Aquí puedes habilitar o deshabilitar el usuario para impedir su acceso a la aplicación
                        </p>
                        <v-btn
                          color="warning"
                          class="ma-2"
                          outlined
                          v-if="usuario.habilitado"
                          @click="usuario.habilitado = 0"
                        >
                        <v-icon
                            left
                            dark
                          >
                            mdi-account-cancel-outline
                          </v-icon>
                          Deshabilitar
                        </v-btn>
                        <v-btn
                          color="success"
                          class="ma-2"
                          outlined
                          v-else
                          @click="usuario.habilitado = 1"
                        >
                        <v-icon
                            left
                            dark
                          >
                            mdi-account-check-outline
                          </v-icon>
                          Habilitar
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row>
                      <v-col cols="12">
                        <v-select
                          v-model="usuario.idTipoUsuario"
                          :items="tipoUsuario"
                          :error-messages="errorTipoUsuario"
                          @input="$v.usuario.idTipoUsuario.$touch()"
                          @blur="$v.usuario.idTipoUsuario.$touch()"
                          item-text="nombre"
                          item-value="id"
                          label="Tipo usuario"
                          class="anadirAsterisco"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row>
                      <v-col cols="12">
                        <v-select
                          v-model="usuario.gruposAsignados"
                          :items="gruposUsuario"
                          item-text="nombreGrupo"
                          item-value="id"
                          :menu-props="{ top: true }"
                          attach
                          chips
                          label="Grupo"
                          multiple
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row>
                      <v-col cols="12">
                        <p class="font-weight-medium">
                          Puedes indicar a continuación las IPs autorizadas para acceder a la aplicación.
                        </p>
                        <p>Nota: * indica que el usuario puede acceder desde cualquier red.</p>
                        <v-textarea
                          prepend-icon="mdi-ip-network-outline"
                          label="IPs permitidas"
                          hint="Puedes añadir varias IPs separándolas por comas y sin dejar espacios"
                          v-model="usuario.ipsConfianza"
                          @input="$v.usuario.ipsConfianza.$touch()"
                          @blur="$v.usuario.ipsConfianza.$touch()"
                          :error-messages="errorIpsConfianza"
                          class="anadirAsterisco"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="text-h6">Estado</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12">
                        <v-textarea label="Mensaje" rows="4" class="pt-0" dense v-model="estado.mensaje"></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6">
                        <v-checkbox label="Ocupado" class="mt-0" dense v-model="estado.ocupado"></v-checkbox>  
                      </v-col>
                      <v-col cols="6" align="end">
                        <v-btn text  color="error" outlined @click="estado.ocupado = false, estado.mensaje = ''" :disabled="(!estado.ocupado || estado.ocupado == false) && (!estado.mensaje || estado.mensaje == '')">Borrar datos</v-btn>  
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel v-if="editandoUsuario">
                  <v-expansion-panel-header class="text-h6">Metadata</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12">
                        <p class="font-weight-bold d-inline">Última modificación:</p> {{ formatearFecha(usuario.updated_at) }} por {{ usuarios[getPosicionIdUsuario(usuario.idUsuarioModificacion)].nombre }} {{ usuarios[getPosicionIdUsuario(usuario.idUsuarioModificacion)].apellidos }}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <p class="font-weight-bold d-inline">Fecha de creación:</p> {{ formatearFecha(usuario.created_at) }} por {{ usuarios[getPosicionIdUsuario(usuario.idUsuarioCreacion)].nombre }} {{ usuarios[getPosicionIdUsuario(usuario.idUsuarioCreacion)].apellidos }}
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels> 
            </v-card-text>
            <div style="flex: 1 1 auto;"></div>
          </v-card>
        </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogCerrar" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">¡Atención!</v-card-title>
          <v-card-text>Vas a salir sin guardar los cambios. ¿Estás seguro?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogCerrar = false">Cancelar</v-btn>
            <v-btn color="error" text @click="cerrar">Salir</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-dialog v-model="dialogIntroducirFecha" persistent max-width="600">
      <v-card>
      <v-card-title>{{editarHorario.dia.charAt(0).toUpperCase() + editarHorario.dia.slice(1)}}</v-card-title>
      <v-card-text class="pb-0">
        <v-row>
          <v-col cols="12" class="ml-5" style="max-width: 100px;">Mañana</v-col>
          <v-col cols="12" sm="4" class="pt-0">
            <v-dialog ref="dialogHora1" v-model="modalHora1" :return-value.sync="editarHorario.entradaManana" persistent width="305px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field 
                  v-model="editarHorario.entradaManana" 
                  label="Inicio" 
                  prepend-icon="mdi-clock-outline" 
                  readonly 
                  :error-messages="errorEntradaManana"
                  @input="$v.editarHorario.entradaManana.$touch()"
                  @blur="$v.editarHorario.entradaManana.$touch()"
                  v-bind="attrs" 
                  v-on="on" 
                  class="anadirAsterisco"
                  >
                </v-text-field>
              </template>
              <v-time-picker v-if="modalHora1" v-model="editarHorario.entradaManana" format="24hr" full-width>
                <v-btn text color="error" @click="$refs.dialogHora1.save(editarHorario.entradaManana = ''), modalHora1 = false">Eliminar</v-btn>
                <v-btn text color="primary" @click="modalHora1 = false">Cancelar</v-btn>
                <v-btn text color="primary" @click="$refs.dialogHora1.save(editarHorario.entradaManana)">Aceptar</v-btn>
              </v-time-picker>
            </v-dialog>
          </v-col>
          <v-col cols="12" sm="4" class="pt-0">
          <v-dialog ref="dialogHora2" v-model="modalHora2" :return-value.sync="editarHorario.salidaManana" persistent width="305px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field 
                v-model="editarHorario.salidaManana" 
                label="Fin" 
                prepend-icon="mdi-clock-outline" 
                readonly 
                :error-messages="errorSalidaManana"
                @input="$v.editarHorario.salidaManana.$touch()"
                @blur="$v.editarHorario.salidaManana.$touch()"
                v-bind="attrs" 
                v-on="on"
                class="anadirAsterisco">
              </v-text-field>
            </template>
            <v-time-picker v-if="modalHora2" v-model="editarHorario.salidaManana" format="24hr" full-width>
              <v-btn text color="error" @click="$refs.dialogHora2.save(editarHorario.salidaManana = ''), modalHora2 = false">Eliminar</v-btn>
              <v-btn text color="primary" @click="modalHora2 = false">Cancelar</v-btn>
              <v-btn text color="primary" @click="$refs.dialogHora2.save(editarHorario.salidaManana)">Aceptar</v-btn>
            </v-time-picker>
          </v-dialog>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="ml-5" style="max-width: 100px;">Tarde</v-col>
          <v-col cols="12" sm="4" class="pt-0">
            <v-dialog ref="dialogHora3" v-model="modalHora3" :return-value.sync="editarHorario.entradaTarde" persistent width="305px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field 
                  v-model="editarHorario.entradaTarde" 
                  label="Inicio" 
                  prepend-icon="mdi-clock-outline" 
                  readonly 
                  :error-messages="errorEntradaTarde"
                  @input="$v.editarHorario.entradaTarde.$touch()"
                  @blur="$v.editarHorario.entradaTarde.$touch()"
                  v-bind="attrs" 
                  v-on="on"
                  class="anadirAsterisco">
                </v-text-field>
              </template>
              <v-time-picker v-if="modalHora3" v-model="editarHorario.entradaTarde" format="24hr" full-width>
                <v-btn text color="error" @click="$refs.dialogHora3.save(editarHorario.entradaTarde = ''), modalHora3 = false">Eliminar</v-btn>
                <v-btn text color="primary" @click="modalHora3 = false">Cancelar</v-btn>
                <v-btn text color="primary" @click="$refs.dialogHora3.save(editarHorario.entradaTarde)">Aceptar</v-btn>
              </v-time-picker>
            </v-dialog>
          </v-col>
          <v-col cols="12" sm="4" class="pt-0">
          <v-dialog ref="dialogHora4" v-model="modalHora4" :return-value.sync="editarHorario.salidaTarde" persistent width="305px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field 
                v-model="editarHorario.salidaTarde" 
                label="Fin" 
                prepend-icon="mdi-clock-outline" 
                readonly 
                :error-messages="errorSalidaTarde"
                @input="$v.editarHorario.salidaTarde.$touch()"
                @blur="$v.editarHorario.salidaTarde.$touch()"
                v-bind="attrs" 
                v-on="on"
                class="anadirAsterisco">
              </v-text-field>
            </template>
            <v-time-picker v-if="modalHora4" v-model="editarHorario.salidaTarde" format="24hr" full-width>
              <v-btn text color="error" @click="$refs.dialogHora4.save(editarHorario.salidaTarde = ''), modalHora4 = false">Eliminar</v-btn>
              <v-btn text color="primary" @click="modalHora4 = false">Cancelar</v-btn>
              <v-btn text color="primary" @click="$refs.dialogHora4.save(editarHorario.salidaTarde)">Aceptar</v-btn>
            </v-time-picker>
          </v-dialog>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogIntroducirFecha = false, $v.editarHorario.$reset()">Cerrar</v-btn>
          <v-btn text @click="guardarHorario()" color="primary">Guardar</v-btn>
      </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import axios from 'axios';
  import { required, minLength, maxLength, email, requiredIf, sameAs } from 'vuelidate/lib/validators';
  import formatearFecha from '../../mixins/formatearFecha';
  export default {
    name: 'FullDialogUsuario',
    mixins: [formatearFecha],
    data () {
      return {
        dialogCerrar: false,
        panel: [],
        items: 5,
        resetPassword: false,
        passconfirm: '',
        showPass: false,
        showPassConfirm: false,
        modalHora1: false,
        dialogIntroducirFecha: false,
        dialogEliminarFecha: false,
        modalHora2: false,
        modalHora3: false,
        modalHora4: false,
        editarHorario: {dia:''},
      }
    },
    validations: {
      usuario: {
        name: { required },
        apellidos: { required },
        email: {
          required,
          email
        },
        password: {
          required: requiredIf(function(){
            return !this.editandoUsuario || this.resetPassword;
          }),
          minLength: minLength(8),
        },
        telefono: { 
          required,
          minLength: minLength(9),
          maxLength: maxLength(9)
        },
        idTipoUsuario: { required },
        ipsConfianza: { required }
      },
      passconfirm:{
        sameAsPassword: sameAs(function(){ 
          // Si no se está editando un usuario (se está creando) o se ha activado el reset de la contraseña, valido que la contraseña repetida sea igual que la contraseña
          if(!this.editandoUsuario || this.resetPassword){
            return this.usuario.password 
          }else{ // Si se está editando un usuario y no se ha activado el reset de la contraseña, no verifico el campo contraseña repetida (no existe)
            return '';
          }
        })
      },
      editarHorario:{
        entradaManana: { required },
        salidaManana: { required },
        entradaTarde: { required },
        salidaTarde: { required }
      }
    },
    methods: {
      ...mapActions('usuarios', ['setDialog', 'setUsuarios']),
      ...mapActions(['setLoading', 'setSnackbar']),
      ...mapActions('horario', ['setEditarHorario']), 
      avisoCerrar(){
        this.dialogCerrar = true;
      },
      cerrar(){
        this.dialogCerrar = false;
        this.setDialog(false);
        this.$v.$reset();
      },
      async guardar(){
        this.setLoading(true);
                
        if(this.editandoUsuario){
          try {
            await axios.patch("/api/usuarios", this.usuario); //USUARIO
            if(this.estado.id){ //ESTADO
              if(this.estado.ocupado != false || this.estado.mensaje){ //si el estado tiene contenido
                await axios.patch('/api/estadoUsuario', this.estado); //editar estado
              }else{//si el estado no tiene contenido
                await axios.delete(`/api/estadoUsuario/${this.estado.id}`); //eliminar estado
              }
            }else{ //si el estado no existe en la bbdd
              if(this.estado.ocupado != false || this.estado.mensaje){ //y tiene contenido
                this.estado.user_id = this.usuario.id;
                await axios.post('/api/estadoUsuario', this.estado); //crear estado
              }
            }
            await axios.patch('/api/horarios', this.horario); //HORARIO

            let respuesta = await axios.get("/api/usuarios");
            this.setUsuarios(respuesta);

            this.setLoading(false);
            this.setDialog(false);
            this.setSnackbar({
              tipo: 'success',
              mensaje: 'Datos guardados correctamente'
            });
          } catch (error) {
            //console.log(error);
            this.setLoading(false);
            this.setDialog(false);
            this.setSnackbar({
              tipo: 'error',
              mensaje: 'Error. No se han podido guardar los datos'
            });
          }
        }else{
          try {
            let respuesta = await axios.post("api/usuarios", this.usuario);
            let usuario = respuesta.data;
            if(this.estado.ocupado != false || this.estado.mensaje){ //si el estado tiene contenido
              this.estado.user_id = usuario.id;
              await axios.post('/api/estadoUsuario', this.estado); //crear estado
            }

            this.horario.forEach(horario => {
              horario.user_id = respuesta.data.id;
            });
            await axios.post('/api/horarios', this.horario);

            respuesta = await axios.get("/api/usuarios");
            this.setUsuarios(respuesta);    
            
            this.setLoading(false);
            this.setDialog(false);
            this.setSnackbar({
              tipo: 'success',
              mensaje: 'Datos guardados correctamente'
            });
          } catch (error) {
            //console.log(error);
            this.setLoading(false);
            this.setDialog(false);
            this.setSnackbar({
              tipo: 'error',
              mensaje: 'Error. No se ha podido crear el usuario'
            });
          }        
        }
      },
      setAvatar(){
        if (this.usuario.name && this.usuario.apellidos){
          this.usuario.avatar = this.usuario.name.charAt(0).toUpperCase()+this.usuario.apellidos.charAt(0).toUpperCase();
        }else{
          this.usuario.avatar = 'NU';
        }
      },
      getPosicionIdUsuario(id){
        //Devuelve la posición del array usuarios del id Usuario que se le pasa
        return this.usuarios.findIndex(x => x.id === id);
      },
      inicializarDatosEdicion(dia){
        this.editarHorario = JSON.parse(JSON.stringify(this.horario[dia]));
        this.dialogIntroducirFecha = true;
      },
      guardarHorario(){
        if((!this.$v.editarHorario.entradaManana.required && this.$v.editarHorario.salidaManana.required) || 
          (this.$v.editarHorario.entradaManana.required && !this.$v.editarHorario.salidaManana.required) ||
          (!this.$v.editarHorario.entradaTarde.required && this.$v.editarHorario.salidaTarde.required) || 
          (this.$v.editarHorario.entradaTarde.required && !this.$v.editarHorario.salidaTarde.required)){
            this.$v.editarHorario.$touch();
        }else{
          //comprobar horaInicio < horaFin
          let horarioCorrecto = true;
          if(this.editarHorario.entradaManana && this.editarHorario.salidaManana){
            if(this.editarHorario.entradaManana > this.editarHorario.salidaManana){ //comprobamos que la entrada sea anterior a la salida
              horarioCorrecto = false;
            }
          }
          if(this.editarHorario.entradaTarde && this.editarHorario.salidaTarde){
            if(this.editarHorario.entradaTarde > this.editarHorario.salidaTarde){
              horarioCorrecto = false;
            }
          }
          if(horarioCorrecto == true){
            this.$v.editarHorario.$reset();
            this.setEditarHorario(this.editarHorario)
            this.dialogIntroducirFecha = false;
            this.editarHorario = {dia:''};
          }else{
            this.$v.editarHorario.$touch();
          }
        }
      }
    },
    computed: {
      ...mapState('usuarios', ['dialog', 'usuario', 'usuarios', 'gruposUsuario', 'editandoUsuario']),
      ...mapState('tipoUsuario', ['tipoUsuario']),
      ...mapState('horario', ['horario']),
      ...mapState('estado', ['estado']),
      ...mapState('equipos', ['equipos']),

      errorNombre () {
        if (this.$v.usuario.name.$dirty){
          if (this.$v.usuario.name.$invalid){
            return 'Introduce el nombre del usuario';
          }
        }
      },
      errorApellido () {
        if (this.$v.usuario.apellidos.$dirty){
          if (this.$v.usuario.apellidos.$invalid){
            return 'Introduce el apellido o apellidos del usuario';
          }
        }
      },
      errorTelefono () {
        if(this.$v.usuario.telefono.$dirty){
          if (!this.$v.usuario.telefono.minLength || !this.$v.usuario.telefono.maxLength){
            return 'Introduce un número válido';
          }
          if (!this.$v.usuario.telefono.required){
            return 'Introduce el telefono del usuario';
          }
        }
      },
      errorEmail () {
        if (this.$v.usuario.email.$dirty){
          if(!this.$v.usuario.email.required){
            return 'Introduce el correo electrónico del usuario';
          }
          if(!this.$v.usuario.email.email){
            return 'Introduce un correo electrónico válido';
          }
        }
      },
      errorPassword () {
        if (this.$v.usuario.password.$dirty){
          if(!this.$v.usuario.password.required){
            return 'Introduce una contraseña';
          }
          if(!this.$v.usuario.password.minLength){
            return `La contraseña debe tener al menos ${this.$v.usuario.password.$params.minLength.min} carácteres`;
          }
        }
      },
      errorPassconfirm () {
        if (this.$v.passconfirm.$dirty){
          if(!this.$v.passconfirm.sameAsPassword){
            return 'Las contraseñas no coinciden';
          }
        }
      },
      errorTipoUsuario () {
        if (this.$v.usuario.idTipoUsuario.$dirty){
          if (!this.$v.usuario.idTipoUsuario.required){
            return 'Selecciona el tipo de usuario';
          }
        }
      },
      errorIpsConfianza () {
        if (this.$v.usuario.ipsConfianza.$dirty){
          if (!this.$v.usuario.ipsConfianza.required){
            return 'Indica una IP o un * para permitir el acceso desde cualquier red';
          }
        }
      },
      errorEntradaManana () {
        if (this.$v.editarHorario.entradaManana.$dirty && this.$v.editarHorario.salidaManana.$dirty){
          if ((!this.$v.editarHorario.entradaManana.required && this.$v.editarHorario.salidaManana.required) || (this.$v.editarHorario.entradaManana.required && !this.$v.editarHorario.salidaManana.required)){
            if(this.editarHorario.entradaManana ==''){
              return 'Es necessaria una hora de entrada y de salida';
            }
          }
        }
      },
      errorSalidaManana () {
        if (this.$v.editarHorario.entradaManana.$dirty && this.$v.editarHorario.salidaManana.$dirty){
          if ((!this.$v.editarHorario.entradaManana.required && this.$v.editarHorario.salidaManana.required) || (this.$v.editarHorario.entradaManana.required && !this.$v.editarHorario.salidaManana.required)){
            if(this.editarHorario.salidaManana ==''){
              return 'Es necessaria una hora de entrada y de salida';
            }
          }
          if(this.editarHorario.entradaManana > this.editarHorario.salidaManana){
            return 'La hora de salida debe de ser mayor que la hora de entrada';
          }
        }
      },
      errorEntradaTarde () {
        if (this.$v.editarHorario.entradaTarde.$dirty && this.$v.editarHorario.salidaTarde.$dirty){
          if ((!this.$v.editarHorario.entradaTarde.required && this.$v.editarHorario.salidaTarde.required) || (this.$v.editarHorario.entradaTarde.required && !this.$v.editarHorario.salidaTarde.required)){
            if(this.editarHorario.entradaTarde ==''){
              return 'Es necessaria una hora de entrada y de salida';
            }
          }
        }
      },
      errorSalidaTarde () {
        if (this.$v.editarHorario.entradaTarde.$dirty && this.$v.editarHorario.salidaTarde.$dirty){
          if ((!this.$v.editarHorario.entradaTarde.required && this.$v.editarHorario.salidaTarde.required) || (this.$v.editarHorario.entradaTarde.required && !this.$v.editarHorario.salidaTarde.required)){
            if(this.editarHorario.salidaTarde ==''){
              return 'Es necessaria una hora de entrada y de salida';
            }
          }
          if(this.editarHorario.entradaTarde > this.editarHorario.salidaTarde){
            return 'La hora de salida debe de ser mayor que la hora de entrada';
          }
        }
      }
    },
    async created(){
      if (this.editandoUsuario){
        this.panel = [0, 5];
      }else{
        this.panel = [...Array(this.items).keys()].map((k, i) => i);
      }
    },
  }
</script>